import { render } from "./NewCompanyDetail.vue?vue&type=template&id=a4ecac5e"
import script from "./NewCompanyDetail.vue?vue&type=script&lang=js"
export * from "./NewCompanyDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__